import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export const absUrl = (u) => (!u || u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export function formatApiError(e) {
    const detail = e?.response?.data?.detail ?? e?.message;
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
            .filter(Boolean)
            .join(" ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
